import { defineMessages } from 'react-intl'

export const paginationMessages = defineMessages({
  rowsPerPageSelectorName: {
    id: 'paginationMessages.rowsPerPageSelectorName',
    description: 'Name for rows per page pagination selector',
    defaultMessage: 'Rows per page selector',
  },
})
